<script lang="ts">
	import { Dropdown, DropdownItem } from "flowbite-svelte";
	import Icon from "#lib/components/Icon.svelte";
	import Button from "#lib/ui/Button/index.js";

	interface Props {
		selectedOption: string | undefined;
	}

	const dropdownKey = "file-type-filter";
	const options = ["Documents", "Images", "Videos"];

	let { selectedOption = $bindable() }: Props = $props();
	let open = $state(false);

	function onClickFilter(option: string) {
		selectedOption = selectedOption === option ? undefined : option;
		open = false;
	}
</script>

<Button class="mr-4 shrink-0" color="alternative" data-action-name="filter-by-file-type" aria-controls={dropdownKey} aria-haspopup="true" aria-expanded={open}>{selectedOption ? selectedOption : "File type"}<Icon name="chevron-down" class="ml-2 h-4 w-4" /></Button>
<Dropdown class="min-w-30.25" bind:open id={dropdownKey}>
	{#each options as option (option)}
		<DropdownItem data-action-name="filter-by-file-type-option" data-action-title={option} on:click={() => onClickFilter(option)} class="flex w-full flex-row items-center justify-between">
			{option}
			{#if selectedOption === option}
				<Icon name="check" class="ml-4 h-4 w-4" />
			{/if}
		</DropdownItem>
	{/each}
</Dropdown>
